import { render, staticRenderFns } from "./ehc-table.vue?vue&type=template&id=6d0a9e50"
import script from "./ehc-table.vue?vue&type=script&lang=js"
export * from "./ehc-table.vue?vue&type=script&lang=js"
import style0 from "./ehc-table.vue?vue&type=style&index=0&id=6d0a9e50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports